<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>
    <b-container v-else class="settings-container-TT">

        <b-list-group-item>
            <b-row class="m-0 settings-title-text">
                Выбор базы торговых точек
            </b-row>

            <label for="branch" class="settings-label">
                Филиал*
            </label>
            <custom-multiselect id="branch"
                                v-model="entity.Branch"
                                :options="entity.branches"
                                class="mb-15"
                                track-by="Id"
                                label="Name"
                                @select="selectBranch" />

            <label v-if="entity.Branch" for="region" class="settings-label">
                Область*
            </label>
            <custom-multiselect v-if="entity.Branch" 
                                id="region"
                                track-by="Id"
                                label="Name"
                                v-model="entity.RegionCode"
                                :options="regions" />
        </b-list-group-item>

        <b-list-group-item class="container-button">

            <b-button class="button-blue" 
                      variant="outline-primary"
                      @click="saveSettings">
                Сохранить
            </b-button>

        </b-list-group-item>

    </b-container>

</template>

<script>
import '@/assets/styles/client/settings/settings.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'

import SettingsModel from '@/store/models/client/settings/Settings'

export default {
    computed: {
        regions: function() {
            return this.entity.Branch
                    ? this.entity.Branch.Regions
                    : [];
        }
    },
    data: function() {
        let load = new Loading();

        this.getSettings(load);
    
        return {
            load: load,
            entity: null
        }
    },
    methods: {
        getSettings: function(load) {
            load.Calculate(true);

            apiService.Client.Settings.Get()
                .then(response => {
                    this.entity = new SettingsModel(response.data);
                    load.Calculate(false);
                    this.getBranches(load);
                })
                .catch(error => load.Calculate(false));
        },
        getBranches: function(load) {
            load.Calculate(true);

            apiService.Client.Users.GetBranches()
                .then(response => {
                    this.entity.mapFromDto(response.data);

                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        selectBranch: function(value) {
            if(!value) return;

            this.entity.RegionCode = value.Regions[0];
        },

        saveSettings: function() {
            if(!this.entity.isValid()) {
                dialogService.showAlert('Предупреждение', 'Для сохранения настроек необходимо выбрать филиал и область');
                return;
            }

            let settingsDto = this.entity.mapToDto();

            this.load.Calculate(true);
            apiService.Client.Settings.PostSave(settingsDto)
                .then(response => {
                    this.load.Calculate(false);
                    dialogService.showAlert('Сообщение', 'Настройки успешно сохранены');                    
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomMultiselect
    }
    
}
</script>